
export type ShortType = 'acquisition' | 'broadcast' | 'category' | 'fashion_show' | 'group' | 'shop' | 'subcategory';


